import React, {
  useContext,
  useState,
  useCallback,
  useRef,
  useEffect,
  Suspense,
} from "react";
import { Button, Col, Nav, Row } from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import "./Tab.css";
import axios from "axios";
import { DataContext } from "../context/DataProvider";
import debounce from "lodash/debounce";
import { v4 as uuidv4 } from "uuid"; // Import UUID for generating unique IDs
import axiosMain from "../axiosMain";
import Cookies from "js-cookie";
import { useNavigate, useSearchParams } from "react-router-dom";

import companyLogo from "../assets/logo/logo.png";
import login from "../assets/login-svgrepo-com.svg";
import logout from "../assets/power-off.png";
import { Tooltip } from "@mui/material";
import Login from "../pages/Login";
import SignUp from "../pages/SignUp";
import { Diversity1Outlined } from "@mui/icons-material";
import newThred from "../assets/new-thred.png";
// import TopUpPayment from "../pages/Payment/TopUpPayment";
import { FaYoutube } from "react-icons/fa";
import ViewPaymentHistory from "../pages/Payment/ViewPaymentHistory";
import PaymentModal from "../pages/Payment/TopUpPayment";
import Header from "./Header";
import gifticons from "../assets/icons/gift-icon-dark.png";
import ReferAndEarn from "../pages/ReferEarn/ReferAndEarn";
import { BASE_URLS } from "../utils/baseUrls";
import { result } from "lodash";


const SearchData = React.lazy(() => import("../pages/SearchData"));

function TabComponent() {
  const {
    tenderGPTData,
    setTenderGPTData,
    setTenderData,
    resultGPTData,
    setResultGPTData,
    setSearch,
    loading,
    setLoading,
    searchType,
    setSearchType,
    newSearch,
    setNewSearch,
    history,
    setHistory,
    showSideBar,
    lastSearch,
    setLastSearchData,
    setIsLoggingOut,
    isLoggingOut,
    setmaxScore,
    maxScore,
    setresmaxScore,
    resmaxScore,
    openPrintModel,
    setSelectFromHistory,
    setIsCallFromTenderPrice,
    setIsCallFromResultPrice, setTidOrTrid
  } = useContext(DataContext);
  //Use Param TCNO



  const currentDate = new Date().toLocaleDateString("en-GB");
  const [search, setSearchData] = useState("");
  const latestTenderRef = useRef(null);
  const latestResultRef = useRef(null);
  const navigate = useNavigate();

  const [openModal, setopenModal] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [walletBalance, setWalletBalance] = useState(0);
  const [walletBalanceInput, setwalletBalanceInput] = useState(null);
  const [viewPaymentModalIsOpen, setViewPaymentModalIsOpen] = useState(false);
  const [showModalReferAndEarn, setShowModalReferAndEarn] = useState(false);
  const colSize = localStorage.getItem("logDetails") !== null ? 10 : 12;
  //Payment Modal
  const [topUpPaymentModal, setTopUpPaymentModal] = useState(false);
  const [objData, setObjData] = useState(null);


  const clickWalletBalanceChange = (val) => {
    setwalletBalanceInput(val);
  }
  const toggleWalletCard = async () => {
    let localstoretoken = localStorage.getItem("logDetails");
    if (localstoretoken !== null) {
      var parseLocalStorage = JSON.parse(localstoretoken);

    }
    await axiosMain
      .post(BASE_URLS + "/Wallet/GetWalletBalance",
        {
          UserId: parseLocalStorage === undefined ? 0 : parseLocalStorage.CustomerId,
          UserDetailId: parseLocalStorage === undefined ? 0 : parseLocalStorage.UserDetailId,
          DomainId: parseLocalStorage === undefined ? 0 : parseLocalStorage.DomainId,
          ItemId: 0,
          CreatedBy: 0,
          ResultAmount: 0.0,
          TenderAmount: 0.0,
          EMDAmount: 0.0,
          ReferenceBy: null,
          TenderProcId: null,
          ReferenceId: null,
          Bidderids: null,
          Querydata: null,
          SubNo: null,
          Offset: 0,
          PageSize: 0,
          FilterStartDate: null,
          FilterEndDate: null,
          ItemPrice: 0.0,
          TenderListFlag: 0,
          ReferenceDetailId: null
        }
      )
      ?.then((res) => {
        if (res.data.StatusCode === 200) {
          // res.data.TransactionCurrency
          setWalletBalance(res.data.Data.WalletBalance);
          setIsVisible(!isVisible);
        }

      })
      ?.catch((err) => console.log(err));

  };
  console.log(searchType, "searchTypesearchType");
  const handleTopUp = async () => {
    let localstoretoken = localStorage.getItem("logDetails");
    if (localstoretoken !== null) {
      var parseLocalStorage = JSON.parse(localstoretoken);
    }

    await axiosMain
      .post(BASE_URLS + "/UserPayment/GenerateOrderTopUp",
        {
          PayEmail: parseLocalStorage === undefined ? "" : parseLocalStorage.Email,
          // IpAddress: "192.168.101.21",
          UserId: parseLocalStorage === undefined ? 0 : parseLocalStorage.CustomerId,
          UserDetailId: parseLocalStorage === undefined ? 0 : parseLocalStorage.UserDetailId,
          // DomainUrl: "tendertiger.co.in",
          NewOrRenew: "New User",
          TopUpAmount: parseFloat(walletBalanceInput),
          OrderFlag: 1,
          ReferenceBy: null,
          TenderProcId: 0,
          ReferenceId: 0,
          ItemId: 0,
          ItemPrice: 0.0
        }
      )
      ?.then((res) => {
        if (res.data.StatusCode === 200) {
          setObjData(res.data);
          setIsVisible(!isVisible);
          setTopUpPaymentModal(true);
          setwalletBalanceInput(null);
        }

      })
      ?.catch((err) => console.log(err));

  };

  const { clearDataContext } = useContext(DataContext);



  const GetTenderAmount = async (tenderList) => {
    try {
      //BASE_URLS

      // Make all API calls for each tender concurrently
      const results_new = await Promise.all(
        tenderList?.TenderList?.map(async (item) => {
          // Construct API URL or params dynamically with item.TCno or other properties
          const response = await axiosMain.post(
            //'https://tendersearchai.tendertiger.co.in/api/' + `GetTenderAmount?tenderValue=${item.tendervalue}&emd=${item.earnestmoney}`

            // 'https://registration.tendertiger.co.in/api/Order/' + `GetTenderResultPrice`,
            BASE_URLS + '/Order/GetTenderResultPrice',
            {
              "TenderValue": parseFloat(item.tendervalue),
              "EMD": parseFloat(item.earnestmoney),
              "ItemId": 4,
              "RefrenceBy": "tender",
            }
          );
          // Attach the tender's identifier so we can match later
          console.log("response.data", response.data)

          // return { tcno: item.tcno, data: response.data };


          const tenderAmountData = response.data;
          setIsCallFromTenderPrice(true);

          setTenderGPTData((prevData) => {
            const latestSearchId = prevData?.at(-1)?.searchId;
            return prevData.map((dataItem) => {
              if (dataItem.searchId === latestSearchId) {
                const updatedTenderList = dataItem.TenderList.map((tender) => {
                  if (tender.tcno === item.tcno) {
                    return {
                      ...tender,
                      // tenderamount: tenderAmountData.tenderamount || 0,
                      // tenderdiscount: tenderAmountData.tenderdiscount || 0,
                      tenderamount: tenderAmountData.ItemPrice || 0,
                      tenderdiscount: tenderAmountData.DiscountPrice || 0,
                    };
                  }
                  return tender;
                });
                return { ...dataItem, TenderList: updatedTenderList };
              }
              return dataItem;
            });
          });
          await new Promise((resolve) => setTimeout(resolve, 200));
        })
      );

      // results = [{ TCno: '123', data: {...} }, { TCno: '456', data: {...} }, ...]

      // Map tenderList to enriched tenders by matching TCno
      // const enrichedTenders = tenderList?.TenderList?.map((tender) => {
      //   const tenderAmountData = results.find((res) => res.tcno === tender.tcno)?.data || {};
      //   return {
      //     ...tender,
      //     tenderamount: tenderAmountData.tenderamount || 0,
      //     tenderdiscount: tenderAmountData.tenderdiscount || 0,
      //     searchId: tender.searchId
      //   };
      // });

      // setTenderGPTData((prevData) => {
      //   const latestSearchId = prevData?.at(prevData.length - 1)?.searchId;
      //   return prevData.map(item => {
      //     if (item.searchId === latestSearchId) {
      //       return { ...item, TenderList: enrichedTenders };
      //     }
      //     return item;
      //   });
      // });



    } catch (error) {
      console.error("Error fetching tender amounts:", error);
    }
  };

  // const GetResultAmount = async (resultList) => {
  //   console.log("resultList", resultList)
  //   try {

  //     const result = await Promise.all(
  //       resultList?.TenderList?.map(async (item) => {
  //         console.log("item", item)
  //         // Construct API URL or params dynamically with item.TCno or other properties
  //         const response = await axiosMain.post(
  //           //'https://tendersearchai.tendertiger.co.in/api/' + `GetTenderAmount?tenderValue=${item.tendervalue}&emd=${item.earnestmoney}`
  //           // 'https://registration.tendertiger.co.in/api/Order/' + `GetTenderResultPrice`,
  //           BASE_URLS + '/Order/GetTenderResultPrice',
  //           {
  //             "contractValue": parseFloat(item.resultvalue),
  //             "itemId": 22,
  //             "RefrenceBy": "result",
  //           }
  //         );
  //         // Attach the tender's identifier so we can match later
  //         console.log("response.data", response.data)

  //         // return { tcno: item.tcno, data: response.data };


  //         const resultAmountData = response.data;
  //         setIsCallFromResultPrice(true);

  //         setResultGPTData((prevData) => {
  //           const latestSearchId = prevData?.at(-1)?.searchId;
  //           return prevData.map((dataItem) => {
  //             if (dataItem.searchId === latestSearchId) {
  //               console.log("dataItem", dataItem)

  //               const updatedResultList = dataItem.ResultList.map((result) => {
  //                 if (result.resultid === item.resultid) {

  //                   return {
  //                     ...result,
  //                     tenderamount: resultAmountData.ItemPrice || 0,
  //                     tenderdiscount: resultAmountData.DiscountPrice || 0,
  //                   };
  //                 }
  //                 return result;
  //               });
  //               return { ...dataItem, ResultList: updatedResultList };
  //             }
  //             return dataItem;
  //           });
  //         });

  //       })
  //     );

  //   }
  //   catch (error) {
  //     console.error("Error fetching tender amounts:", error);
  //   }

  // }


  // const GetTenderAmount = async (tenderList) => {

  //   tenderList.map(async item => {
  //     try {
  //       const response = await axiosMain
  //         .get(BASE_URLS + "GetTenderAmount?tenderValue=30161913.73&emd=302000.0");

  //       // Assuming response.data is an array of objects like [{ id: 1, tenderamount: 1000, tenderdiscount: 50 }, ...]
  //       const amountData = response.data;

  //       // Merge amountData into tenderList
  //       const enrichedTenders = tenderList.map(tender => {
  //         const amountInfo = amountData.find(a => a.id === tender.id) || {};
  //         return {
  //           ...tender,
  //           tenderamount: amountInfo.tenderamount || 0,
  //           tenderdiscount: amountInfo.tenderdiscount || 0,
  //         };
  //       });

  //       // Update the tender data state with enriched data
  //       setTenderData(prevData => {
  //         // Assuming prevData has only one item or you want to replace all tender data
  //         // If you have multiple sets, you might want to merge properly here
  //         return {
  //           ...prevData,
  //           TenderList: enrichedTenders,
  //         };
  //       });

  //     } catch (error) {
  //       console.error("Error fetching tender amounts:", error);
  //     }
  //   })
  // };




  const debouncedFetchData = useCallback(
    debounce(async (searchId, url, type, searchkeyword) => {

      try {
        const response = await axiosMain.post(url, {
          searchkeyword:
            searchType === "Tender"
              ? tenderGPTData.length > 0 && history?.length > 0
                ? searchkeyword === "" ? tcNoGenByParam : searchkeyword
                : search === "" ? tcNoGenByParam : search
              : resultGPTData.length > 0 && history?.length > 0
                ? searchkeyword === "" ? tcNoGenByParam : searchkeyword
                : search === "" ? tcNoGenByParam : search,
          total: 50,
          rescount: 0,
          maxScore: 0,
        });
        console.log("API Response:", response.data);
        setSearch(
          tenderGPTData.length > 0 && history?.length > 0
            ? searchkeyword === "" ? tcNoGenByParam : searchkeyword
            : search === "" ? tcNoGenByParam : search
        );
        setLastSearchData(
          tenderGPTData.length > 0 && history?.length > 0
            ? searchkeyword === "" ? tcNoGenByParam : searchkeyword
            : search === "" ? tcNoGenByParam : search
        );
        var highestScoreTender = 0;
        if (type === "Tender") {
          setTenderData(response.data);
          // GetTenderAmount(response.data);
          setTenderGPTData((prevData) => {
            const existingSearchIndex = prevData.findIndex(
              (item) => item.searchId === searchId
            );
            if (existingSearchIndex > -1) {
              const updatedGPTData = [...prevData];
              updatedGPTData[existingSearchIndex] = {
                ...updatedGPTData[existingSearchIndex],
                TenderList: [
                  ...updatedGPTData[existingSearchIndex].TenderList,
                  ...response.data.TenderList,
                ],
              };
              const filtertenderdat = updatedGPTData
                ?.filter((item) => item.searchId === searchId)
                ?.at(0)?.TenderList;

              if (filtertenderdat?.length > 0) {
                highestScoreTender = filtertenderdat.reduce((max, tender) => {
                  return parseFloat(tender.elastic_score) >
                    parseFloat(max.elastic_score)
                    ? tender
                    : max;
                }, filtertenderdat[0])?.elastic_score;
              }

              setmaxScore(
                parseFloat(
                  (
                    Math.floor(parseFloat(highestScoreTender) * 100) / 100
                  ).toFixed(2)
                )
              );
              return updatedGPTData;
            } else {
              setmaxScore(0);
              let searchquery =
                tenderGPTData.length > 0 && history?.length > 0
                  ? searchkeyword === "" ? tcNoGenByParam : searchkeyword
                  : search === "" ? tcNoGenByParam : search;
              return [
                ...prevData,
                {
                  searchId,
                  search: searchquery,
                  TenderList: response.data.TenderList,
                },
              ];
            }
          });
        } else if (type === "Result") {
          var reshighestScoreTender = 0;
          // GetResultAmount(response?.data)
          setResultGPTData((prevData) => {
            const existingSearchIndex = prevData.findIndex(
              (item) => item.searchId === searchId
            );
            if (existingSearchIndex > -1) {
              const updatedGPTData = [...prevData];
              updatedGPTData[existingSearchIndex] = {
                ...updatedGPTData[existingSearchIndex],
                ResultList: [
                  ...updatedGPTData[existingSearchIndex].ResultList,
                  ...response.data.TenderList,
                ],
              };
              const resfiltertenderdat = updatedGPTData
                ?.filter((item) => item.searchId === searchId)
                ?.at(0)?.ResultList;

              if (resfiltertenderdat?.length > 0) {
                reshighestScoreTender = resfiltertenderdat.reduce(
                  (max, tender) => {
                    return parseFloat(tender.elastic_score) >
                      parseFloat(max.elastic_score)
                      ? tender
                      : max;
                  },
                  resfiltertenderdat[0]
                )?.elastic_score;
              }

              setresmaxScore(
                parseFloat(
                  (
                    Math.floor(parseFloat(reshighestScoreTender) * 100) / 100
                  ).toFixed(2)
                )
              );

              return updatedGPTData;
            } else {
              setresmaxScore(0);
              return [
                ...prevData,
                { searchId, search, ResultList: response.data.TenderList },
              ];
            }
          });

        }

        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching data:", error);
      }
    }, 500),
    [search, setTenderData, setResultGPTData, setLoading, history]
  );

  const debouncedFetchDataOnTabChange = useCallback(
    debounce(async (searchId, url, type, lastSearchh) => {
      try {

        const response = await axiosMain.post(url, {
          searchkeyword: lastSearchh,
          total: 50,
          rescount: 0,
          maxScore: resmaxScore,
        });
        console.log("API Response:", response.data);
        setSearch(lastSearchh);
        // setLastSearchData(lastSearch);
        if (type === "Tender") {
          setTenderData(response.data);
          setTenderGPTData((prevData) => {
            const existingSearchIndex = prevData.findIndex(
              (item) => item.searchId === searchId
            );
            if (existingSearchIndex > -1) {
              const updatedGPTData = [...prevData];
              updatedGPTData[existingSearchIndex] = {
                ...updatedGPTData[existingSearchIndex],
                TenderList: [
                  ...updatedGPTData[existingSearchIndex].TenderList,
                  ...response.data.TenderList,
                ],
              };
              return updatedGPTData;
            } else {
              return [
                ...prevData,
                {
                  searchId,
                  search: lastSearch,
                  TenderList: response.data.TenderList,
                },
              ];
            }
          });
        } else if (type === "Result") {
          var reshighestScoreTender = 0;
          // GetResultAmount(response.data);
          setResultGPTData((prevData) => {
            const existingSearchIndex = prevData.findIndex(
              (item) => item.searchId === searchId
            );
            if (existingSearchIndex > -1) {
              const updatedGPTData = [...prevData];
              updatedGPTData[existingSearchIndex] = {
                ...updatedGPTData[existingSearchIndex],
                ResultList: [
                  ...updatedGPTData[existingSearchIndex].ResultList,
                  ...response.data.TenderList,
                ],
              };
              const resfiltertenderdat = updatedGPTData
                ?.filter((item) => item.searchId === searchId)
                ?.at(0)?.ResultList;

              if (resfiltertenderdat?.length > 0) {
                reshighestScoreTender = resfiltertenderdat.reduce(
                  (max, tender) => {
                    return parseFloat(tender.elastic_score) >
                      parseFloat(max.elastic_score)
                      ? tender
                      : max;
                  },
                  resfiltertenderdat[0]
                )?.elastic_score;
              }

              setresmaxScore(
                parseFloat(
                  (
                    Math.floor(parseFloat(reshighestScoreTender) * 100) / 100
                  ).toFixed(2)
                )
              );
              return updatedGPTData;
            } else {
              setresmaxScore(0);
              return [
                ...prevData,
                {
                  searchId,
                  search: lastSearch,
                  ResultList: response.data.TenderList,
                },
              ];
            }
          });
        }

        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching data:", error);
      }
    }, 500),
    [search, setTenderData, setResultGPTData, setLoading]
  );

  const [searchParams] = useSearchParams();
  // const tcNoGenByParam = searchParams.get("TcNo");

  const TID = searchParams.get("TID");
  const TRID = searchParams.get("TRID");

  let tcNoGenByParam = TID === null ? TRID : TID;

  console.log(tcNoGenByParam, "tcNoGenByParam1");


  useEffect(() => {

    if (tcNoGenByParam !== null && tcNoGenByParam !== undefined) {
      setTidOrTrid(parseInt(tcNoGenByParam));
      if (TID) {
        // tcNoGenByParam = TID;
        // setSearchType("Tender");
        handleChangeTab("Tender");
        // handleSubmit("Tender");

      } else if (TRID) {
        // tcNoGenByParam = TRID;
        // setSearchType("Result");
        handleChangeTab("Result");
        // handleSubmit("Result");

      }

    }
  }, [tcNoGenByParam]);

  useEffect(() => {
    if (TRID !== null && TRID !== undefined && searchType !== "Tender") {
      handleSubmitForResult(TRID);
    }
    if (TID !== null && TID !== undefined && searchType === "Tender") {
      // handleSubmitForResult(TID);
      handleSubmit();
    }
  }, [searchType])

  useEffect(() => {
    if (localStorage.getItem("logDetails") === null) {
      setIsLoggingOut(false);
    } else {
      setIsLoggingOut(true);
    }
  }, []);
  useEffect(() => {
    if (newSearch) {
      if (searchType === "Tender" && latestTenderRef.current) {
        latestTenderRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      } else if (searchType === "Result" && latestResultRef.current) {
        latestResultRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }
  }, [newSearch, searchType, setNewSearch]);

  const handleChangeTab = (eOrType) => {
    // let type = e.target.textContent;
    let type;

    if (typeof eOrType === "string") {
      type = eOrType;
    } else {
      type = eOrType?.target?.textContent;
    }

    setSearchType(type);
    // setHistory(
    //   e.target.textContent === "Tender"
    //     ? Cookies.get("tenderGPTDataHistory") === undefined
    //       ? []
    //       : [...new Set([...JSON.parse(Cookies.get("tenderGPTDataHistory"))])]
    //     : Cookies.get("resultGPTDataHistory") === undefined
    //     ? []
    //     : // ...resultGPTDataHistory?.map((ele) => ele.search),
    //       [...new Set([...JSON.parse(Cookies.get("resultGPTDataHistory"))])]
    // );

    // setTenderGPTData([]);
    // setResultGPTData([]);
    // setLoading(true);
    // // setSearch(lastSearch);
    // // const searchId = uuidv4(); // Generate a unique ID for the search
    const searchId = uuidv4();
    //FOR LATEST SEARCH
    // if (e.target.textContent === "Tender") {
    //   if (lastSearch !== "") {
    //     setTenderGPTData([
    //       ...tenderGPTData,
    //       { searchId: searchId, search: lastSearch, TenderList: [] },
    //     ]);
    //     //  
    //     debouncedFetchDataOnTabChange(
    //       searchId,
    //       "https://tendersearchai.tendertiger.co.in/api/tender/GetTendersListBeforeLoginAI",
    //       "Tender"
    //     );

    //   }
    // }
    if (type !== "Tender" && resultGPTData?.length === 0) {
      // else {
      if (lastSearch !== "") {
        //SET HISTORY TO LOCAL STORAGE
        // const storageKey =
        //   e.target.textContent === "Tender"
        //     ? "tenderLocalStorageHistory"
        //     : "resultLocalStorageHistory";

        // // Fetch the existing data from localStorage
        // let storedHistory = JSON.parse(localStorage.getItem(storageKey)) || [];

        // // Create a new history object with the current date
        // let newHistoryEntry = {
        //   date: currentDate,
        //   history: lastSearch,
        // };

        // // Add the new entry to the stored history array
        // storedHistory.push(newHistoryEntry);

        // // Save the updated history array back to localStorage
        // localStorage.setItem(
        //   storageKey,
        //   JSON.stringify([...new Set(storedHistory)])
        // );

        setResultGPTData([
          ...resultGPTData,
          { searchId: searchId, search: lastSearch, ResultList: [] },
        ]);
        setLoading(true);
        //  
        debouncedFetchDataOnTabChange(
          searchId,
          "https://tenderresultai.tendertiger.co.in/api/result/GetResultListBeforeLogin",
          "Result",
          lastSearch,
          resmaxScore
        );
      }
    }
  };
  function removeConsecutiveDuplicates(text) {
    return text.filter((word, index) => word !== text[index + 1]).join(" ");
  }

  function syncPosTags(data1, data2) {
    const filteredData2PosTags = Object.fromEntries(
      Object.entries(data2.posTags).filter(([, tags]) => tags.length > 0)
    );
    if (
      data2.posTags.location.length === 0 &&
      data2.posTags.companyname.length === 0
    ) {
      data1.clean_query = ` ${data2.clean_query + " " + data1.clean_query}`;
    } else {
      // Loop through each key in posTags of data1
      Object.keys(filteredData2PosTags).forEach((key) => {
        const tags1 = data1.posTags[key];
        const tags2 = data2.posTags[key];

        // Check if data2 has tags for this key and compare them to data1's tags

        if (tags2 && JSON.stringify(tags1) !== JSON.stringify(tags2)) {
          // Replace tags in data1 with tags from data2 if they are different
          data1.posTags[key] = [...tags2];

          // Also remove each of these tags from the clean_query in data1 if it exists
          tags1.forEach((tag) => {
            const regex = new RegExp(`\\b${tag}\\b`, "gi"); // Match whole word, case insensitive

            data1.clean_query = data1.clean_query.replace(regex, "").trim();
          });

          // Add the new tags from data2 at the end of data1.clean_query
          tags2.forEach((tag) => {
            if (!data1.clean_query.toLowerCase().includes(tag.toLowerCase()) && !data1.clean_query.toLowerCase().includes(data2.clean_query.toLowerCase())) {
              data1.clean_query += ` ${data2.clean_query}`;
            }
          });
        }
      });
    }

    return {
      ...data1,
      clean_query: removeConsecutiveDuplicates(
        data1.clean_query.split(" ").filter((ele) => ele.length !== 0)
      ),
    };
  }
  const handleSubmitForResult = (SearchVal) => {
    // e.preventDefault();
    // if (e) e.preventDefault();
    setLoading(true);
    const searchId = uuidv4(); // Generate a unique ID for the search

    setResultGPTData([
      ...resultGPTData,
      { searchId, search: SearchVal, ResultList: [] },
    ]);
    setNewSearch(searchId); // Set the current search ID for scrolling
    debouncedFetchData(
      searchId,
      "https://tenderresultai.tendertiger.co.in/api/result/GetResultListBeforeLogin",
      "Result"
    );


    //setLastSearchData(search);

    setSearchData("");
    // }
  };

  const handleSubmit = (e) => {
    // e.preventDefault();
    if (e) e.preventDefault();
    setLoading(true);
    if (e) {
      setTidOrTrid(0);
    }
    // const existingSearch =
    //   searchType === "Tender"
    //     ? tenderGPTData.find((item) => item.search === search)
    //     : resultGPTData.find((item) => item.search === search);

    // if (existingSearch) {
    //   const cardId = existingSearch.searchId; // Use searchId as an identifier
    //   const cardElement = document.getElementById(cardId);
    //   if (cardElement) {
    //     cardElement.scrollIntoView({ behavior: "smooth", block: "start" });
    //   }
    //   setLoading(false);
    //   setSearchData("");
    // } else {
    const searchId = uuidv4(); // Generate a unique ID for the search

    // if (tenderGPTData.length > 0 || resultGPTData.length > 0) {
    if (history.length > 0 && (searchType === "Tender" ? tenderGPTData.length > 0 : resultGPTData.length > 0)) {
      const secondLastSearch =
        searchType === "Tender"
          ? tenderGPTData.at(tenderGPTData.length - 1)?.search
          : resultGPTData.at(resultGPTData.length - 1)?.search;

      axiosMain
        .post(
          "https://tendersearchai.tendertiger.co.in/api/tender/GetProcessText?text=" +
          secondLastSearch,
          {}
        )
        .then((res) => {
          axiosMain
            .post(
              "https://tendersearchai.tendertiger.co.in/api/tender/GetProcessText?text=" +
              search,
              {}
            )
            .then((response) => {
              // console.log(
              //   syncPosTags(
              //     {
              //       ...res.data,
              //       posTags: {
              //         companyname: res.data.posTags.companyname,
              //         location: [
              //           ...res.data.posTags.cityname,
              //           ...res.data.posTags.statename,
              //           ...res.data.posTags.countries,
              //           ...res.data.posTags.region,
              //         ],
              //       },
              //     },
              //     {
              //       ...response.data,
              //       posTags: {
              //         companyname: response.data.posTags.companyname,
              //         location: [
              //           ...response.data.posTags.cityname,
              //           ...response.data.posTags.statename,
              //           ...response.data.posTags.countries,
              //           ...response.data.posTags.region,
              //         ],
              //       },
              //     }
              //   ),
              //   "search Data"
              // );

              let search = syncPosTags(
                {
                  ...res.data,
                  posTags: {
                    companyname: res.data.posTags.companyname,
                    location: [
                      ...res.data.posTags.cityname,
                      ...res.data.posTags.statename,
                      ...res.data.posTags.countries,
                      ...res.data.posTags.region,
                      ...res.data.posTags.continents,
                    ],
                  },
                },
                {
                  ...response.data,
                  posTags: {
                    companyname: response.data.posTags.companyname,
                    location: [
                      ...response.data.posTags.cityname,
                      ...response.data.posTags.statename,
                      ...response.data.posTags.countries,
                      ...response.data.posTags.region,
                      ...response.data.posTags.continents,
                    ],
                  },
                }
              )?.clean_query;
              if (searchType === "Tender") {
                setTenderGPTData([
                  ...tenderGPTData,
                  { searchId, search, TenderList: [] },
                ]);
                setNewSearch(searchId);
                // Set the current search ID for scrolling
                // setHistory([...new Set([...history, search])]);
                //SET HISTORY TO LOCAL STORAGE
                // const storageKey =
                //   searchType === "Tender"
                //     ? "tenderLocalStorageHistory"
                //     : "resultLocalStorageHistory";

                // // Fetch the existing data from localStorage
                // let storedHistory =
                //   JSON.parse(localStorage.getItem(storageKey)) || [];

                // // Create a new history object with the current date
                // let newHistoryEntry = {
                //   date: currentDate,
                //   history: search,
                // };

                // // Add the new entry to the stored history array
                // storedHistory.push(newHistoryEntry);

                // // Save the updated history array back to localStorage
                // localStorage.setItem(
                //   storageKey,
                //   JSON.stringify([...new Set(storedHistory)])
                // );
                setSearch(search);
                const apiurls =
                  localStorage.getItem("logDetails") == null
                    ? "https://tendersearchai.tendertiger.co.in/api/tender/GetTendersListBeforeLoginAI" //https://tendersearchai.tendertiger.co.in/api/tender/GetTendersListBeforeLoginAI"
                    : "https://tendersearchai.tendertiger.co.in/api/tender/GetTendersListAI";
                //setmaxScore(0);
                debouncedFetchData(searchId, apiurls, "Tender", search);
              } else {
                setResultGPTData([
                  ...resultGPTData,
                  { searchId, search, ResultList: [] },
                ]);
                // setHistory([...new Set([...history, search])]);
                //SET HISTORY TO LOCAL STORAGE
                // const storageKey =
                //   searchType === "Tender"
                //     ? "tenderLocalStorageHistory"
                //     : "resultLocalStorageHistory";

                // // Fetch the existing data from localStorage
                // let storedHistory =
                //   JSON.parse(localStorage.getItem(storageKey)) || [];

                // // Create a new history object with the current date
                // let newHistoryEntry = {
                //   date: currentDate,
                //   history: search,
                // };

                // // Add the new entry to the stored history array
                // storedHistory.push(newHistoryEntry);

                // // Save the updated history array back to localStorage
                // localStorage.setItem(
                //   storageKey,
                //   JSON.stringify(storedHistory)
                // );

                setNewSearch(searchId); // Set the current search ID for scrolling
                debouncedFetchData(
                  searchId,
                  "https://tenderresultai.tendertiger.co.in/api/result/GetResultListBeforeLogin",
                  "Result",
                  search
                );
              }
            })
            .catch((err) => {
              setLoading(false);
              console.log(err);
            });
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
        });
    }
    // } 

    else {
      if (searchType === "Tender") {
        // setTenderGPTData([
        //   ...tenderGPTData,
        //   { searchId, search, TenderList: [] },
        // ]);
        setNewSearch(searchId); // Set the current search ID for scrolling
        // setHistory([...new Set([...history, search])]);
        //SET HISTORY TO LOCAL STORAGE
        // const storageKey =
        //   searchType === "Tender"
        //     ? "tenderLocalStorageHistory"
        //     : "resultLocalStorageHistory";

        // // Fetch the existing data from localStorage
        // let storedHistory = JSON.parse(localStorage.getItem(storageKey)) || [];

        // // Create a new history object with the current date
        // let newHistoryEntry = {
        //   date: currentDate,
        //   history: search,
        // };

        // // Add the new entry to the stored history array
        // storedHistory.push(newHistoryEntry);

        // // Save the updated history array back to localStorage
        // localStorage.setItem(
        //   storageKey,
        //   JSON.stringify([...new Set(storedHistory)])
        // );
        const apiurls =
          localStorage.getItem("logDetails") == null
            ? "https://tendersearchai.tendertiger.co.in/api/tender/GetTendersListBeforeLoginAI" //https://tendersearchai.tendertiger.co.in/api/tender/GetTendersListBeforeLoginAI"
            : "https://tendersearchai.tendertiger.co.in/api/tender/GetTendersListAI";
        //setmaxScore(0);
        debouncedFetchData(searchId, apiurls, "Tender");
      }

      else {
        setResultGPTData([
          ...resultGPTData,
          { searchId, search, ResultList: [] },
        ]);
        // setHistory([...new Set([...history, search])]);
        //SET HISTORY TO LOCAL STORAGE
        // const storageKey =
        //   searchType === "Tender"
        //     ? "tenderLocalStorageHistory"
        //     : "resultLocalStorageHistory";

        // // Fetch the existing data from localStorage
        // let storedHistory = JSON.parse(localStorage.getItem(storageKey)) || [];

        // // Create a new history object with the current date
        // let newHistoryEntry = {
        //   date: currentDate,
        //   history: search,
        // };

        // // Add the new entry to the stored history array
        // storedHistory.push(newHistoryEntry);

        // // Save the updated history array back to localStorage
        // localStorage.setItem(storageKey, JSON.stringify(storedHistory));

        setNewSearch(searchId); // Set the current search ID for scrolling
        debouncedFetchData(
          searchId,
          "https://tenderresultai.tendertiger.co.in/api/result/GetResultListBeforeLogin",
          "Result"
        );
      }
    }
    //setLastSearchData(search);

    setSearchData("");
    // }
  };
  const fnlogout = () => {
    localStorage.removeItem("logDetails");
    localStorage.removeItem("token");
    setIsLoggingOut(false);
    clearDataContext();
  };

  return (
    <>
      {/* <Tab.Container id="left-tabs-example" defaultActiveKey="Tender"> */}
      <Tab.Container id="left-tabs-example" activeKey={searchType} defaultActiveKey={searchType}>
        <div
          className={showSideBar ? "chat-container" : "chat-container-clospan"}
        >
          <Header />
          {/* <div className="nav-bar-style">
            <div className="logo-container main-header">
              <span
                className={
                  showSideBar
                    ? "company-chat-logo"
                    : "company-chat-logo-clospan"
                }
                onClick={() => navigate("/chat")}
              >
                <img src={companyLogo} className="ps-3 company-logo-style" />
              </span>

              <div className="right">


                <ul className="right-menu">


                  {localStorage.getItem("logDetails") !== null &&
                    (<><li className="nav-item showMyWallet nav-item-mywallet" >
                     
                      <div class="menu-item"><i class="fas fa-wallet"></i><span> My Wallet </span></div>

                      {isVisible && (
                        <div className="sm-Wallet-card" id="walletCard" onClick={(e) => e.stopPropagation()}>
                          <div className="sm-Wallet-card-">
                            <div className="tt-wallet-card">
                              <div className="card-footer">
                                <p>Available Points</p>
                                <h1 className="balance-amount" id="walletBalance">
                                  {walletBalance}
                                  <span className="tt-wallet-card-points"> Points</span>
                                </h1>
                              </div>

                              <div className="add-new-topup mt-2">
                                <div className="d-flex align-items-center">
                                  <div className="input-group">
                                    <input
                                      type="number"
                                      className="form-control"
                                      placeholder="Enter Amount"
                                      aria-label="Enter Amount"
                                      id="amountInput"
                                      value={walletBalanceInput}
                                      onChange={(e) => clickWalletBalanceChange(e.target.value)}
                                    />
                                    <button style={{ backgroundColor: '#353535', color: "white" }} className="btn top-up-button" type="button" onClick={handleTopUp}>
                                      Top Ups
                                    </button>
                                  </div>
                                </div>
                              </div>

                              <a className="label-history" onClick={() => { setViewPaymentModalIsOpen(true) }}>
                                View History &gt;&gt;
                              </a>
                            </div>
                          </div>
                        </div>
                      )}
                    </li>
                      <li>
                        <div className="menu-item"
                          onClick={()=>navigate('/Refer')}>
                          <i className="fas fa-gift"></i>
                          <span> Refer & Earn </span>
                        </div>
                      </li>

                      <li>
                        <div className="menu-item">
                          <i className="fas fa-heart"></i>
                          <span> Favorite </span>
                        </div>
                      </li>

                      <li>
                        <div className="menu-item">
                          <i className="fas fa-shopping-bag"></i>



                          <span> Order</span>
                        </div>
                      </li></>)}


                  <li>
                    <div className="login-btn">
                      {isLoggingOut === true ? (
                        <div className="menu-item" onClick={fnlogout} style={{ cursor: "pointer" }}> <i className="fa fa-sign-out-alt"></i>
                          <span>Logout</span>
                        </div>
                      ) : (

                        <div className="menu-item" onClick={() => setopenModal(true)} style={{ cursor: "pointer" }}> <i className="fa fa-sign-in-alt"></i>
                          <span>Login</span>
                        </div>

                      )}
                    </div>
                  </li>

                  <li className="d-none">
                    <div className="">
                      <label htmlFor="theme-selector">Theme:</label>
                      <select id="theme-selector">
                        <option value="default">Default</option>
                        <option value="dark">Dark</option>
                        <option value="light">Light</option>
                      </select>
                    </div>
                  </li>
                </ul>
              </div>

            </div>
          </div> */}
          <Col
            md={12}
            sm={12}
            xs={12}
            className="main-container"
            style={{
              flex: "1",
              overflow: "auto",

              alignItems:
                searchType === "Tender"
                  ? tenderGPTData?.length > 0
                    ? ""
                    : "center"
                  : resultGPTData?.length > 0
                    ? ""
                    : "center",
            }}
          >
            <Tab.Content className="tenderlist-container-before-search tender-view">
              <Tab.Pane eventKey="Tender">
                {tenderGPTData?.length > 0 ? (
                  // <SearchData ref={latestTenderRef} />
                  <Suspense fallback={<div className="text-loading">Loading...</div>}>
                    <SearchData TID={TID} TRID={TRID} />
                  </Suspense>
                ) : (
                  <div className="row g-0 tender-details tender-search-info">
                    {/* Key Values Section */}
                    <div className="col-lg-4 col-md-6">
                      <div className="twm-jobs-grid-style1 card card">
                        <div className="twm-job-post-duration card-header text-center">
                          <span className="card-title">Examples</span>
                        </div>
                        <div className="twm-mid-content card-body card-body">
                          <ul className="list-search">
                            <li> Show me tenders of Road</li>
                            <li> Show me tenders of Road from Gujarat</li>
                            <li>
                              Show me tenders of Road from Gujarat for R&B
                              Department
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    {/* Key Date Section  */}
                    <div className="col-lg-4 col-md-6">
                      <div className="twm-jobs-grid-style1 card card">
                        <div className="twm-job-post-duration card-header text-center">
                          <span className="card-title">Capabilities</span>
                        </div>
                        <div className="twm-mid-content card-body">
                          <ul className="list-search">
                            <li> Show me tenders of Road</li>
                            <li> Show me tenders of Road from Gujarat</li>
                            <li>
                              Show me tenders of Road from Gujarat for R&B
                              Department
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    {/* Key Location Section */}
                    <div className="col-lg-4 col-md-6">
                      <div className="twm-jobs-grid-style1 card">
                        <div className="twm-job-post-duration card-header text-center">
                          <span className="card-title">Limitations</span>
                        </div>
                        <div className="twm-mid-content card-body">
                          <ul className="list-search">
                            <li> Show me tenders of Road</li>
                            <li> Show me tenders of Road from Gujarat</li>
                            <li>
                              Show me tenders of Road from Gujarat for R&B
                              Department
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </Tab.Pane>

              <Tab.Pane eventKey="Result">
                {resultGPTData?.length > 0 ? (
                  // <SearchData ref={latestResultRef} />
                  <Suspense fallback={<div className="text-loading">Loading</div>}>
                    <SearchData TID={TID} TRID={TRID} />
                  </Suspense>
                ) : (
                  <div className="row g-0 tender-details tender-search-info">
                    {/* Key Values Section */}
                    <div className="col-lg-4 col-md-6">
                      <div className="twm-jobs-grid-style1 card card">
                        <div className="twm-job-post-duration card-header text-center">
                          <span className="card-title">Examples</span>
                        </div>
                        <div className="twm-mid-content card-body card-body">
                          <ul className="list-search">
                            <li> Show me tenders of Road</li>
                            <li> Show me tenders of Road from Gujarat </li>
                            <li>
                              Show me tenders of Road from Gujarat for R&B
                              Department
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    {/* Key Date Section  */}
                    <div className="col-lg-4 col-md-6">
                      <div className="twm-jobs-grid-style1 card card">
                        <div className="twm-job-post-duration card-header text-center">
                          <span className="card-title">Capabilities</span>
                        </div>
                        <div className="twm-mid-content card-body">
                          <ul className="list-search">
                            <li> Show me tenders of Road</li>
                            <li> Show me tenders of Road from Gujarat</li>
                            <li>
                              Show me tenders of Road from Gujarat for R&B
                              Department
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    {/* Key Location Section */}
                    <div className="col-lg-4 col-md-6">
                      <div className="twm-jobs-grid-style1 card">
                        <div className="twm-job-post-duration card-header text-center">
                          <span className="card-title">Limitations</span>
                        </div>
                        <div className="twm-mid-content card-body">
                          <ul className="list-search">
                            <li> Show me tenders of Road</li>
                            <li> Show me tenders of Road from Gujarat</li>
                            <li>
                              Show me tenders of Road from Gujarat for R&B
                              Department
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </Tab.Pane>
            </Tab.Content>
          </Col>
          {/* {openPrintModel === null ? ( */}

          <div className="row">
            {localStorage.getItem("logDetails") !== null && <Col md={2} sm={2} xs={2} style={{ backgroundColor: "#f4f4f4" }}>
              <div className="refere-earn-card card" style={{ margin: "14px 0px 0px 30px" }}>
                <div>
                  <div className="d-flex align-items-center">
                    <img src={gifticons} alt="gift-icon" /><h6 className="mb-0 ms-2">Refer &amp; Earn </h6></div>
                  <p>Earn 500 Bonus Credits!</p>
                </div>
                <button type="button" className="btn btn-primary btn-invite" onClick={() => { setShowModalReferAndEarn(true) }}>
                  Invite Now
                </button>
              </div>
            </Col>}

            <Col md={colSize} sm={colSize} xs={colSize} className="search">
              <form onSubmit={handleSubmit} className={localStorage.getItem("logDetails") !== null ? "text-center" : "text-center  m-auto"}>
                <div style={{ display: 'flex', flexDirection: "column", gap: "0px" }}>
                  <Nav
                    variant="pills"
                    id="searchTab"
                  // style={{
                  //   background: "#fff",
                  //   borderRadius: "20px",
                  //   width: "9.8rem",
                  //   border: "1px solid #626262",
                  //   marginBottom: "5px",
                  // }}
                  >
                    <Nav.Item>
                      <Nav.Link
                        eventKey="Tender"
                        onClick={handleChangeTab}
                        disabled={loading}
                      >
                        Tender
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        eventKey="Result"
                        onClick={handleChangeTab}
                        disabled={loading}
                      >
                        Result
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="h-0 p-0">
                      <button
                        type="button"
                        className="p-0 bg-transparent border-0 mb-0 m-0 h-0 new-thred"
                        // disabled={loading || search === ""}
                        style={{ cursor: "pointer" }}
                        onClick={() => {

                          setTenderGPTData([]);
                          setSearch("");
                          setLoading(false);
                          setNewSearch(null);
                          setResultGPTData([]);
                          setLastSearchData("");
                          setmaxScore(0);
                          setresmaxScore(0);
                          setIsCallFromTenderPrice(false);
                          setIsCallFromResultPrice(false);
                        }}
                      >
                        <img src={newThred} className="p-0 bg-transparent m-0" />
                      </button>
                    </Nav.Item>
                    <Nav.Item className="p-0 ms-auto me-3 pt-2 learn-youtub">
                      <button
                        type="button"
                        className="p-0 bg-transparent border-0 mb-0 m-0 new-thred "
                        // disabled={loading || search === ""}
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          window.open(
                            "https://youtube.com/@tendergptofficial?si=ONR7PN2DB5nDu8Tl",
                            "_blank"
                          );
                        }}
                      >
                        <span
                          style={{
                            fontFamily: "'Roboto', Arial, Helvetica, sans-serif",
                            fontSize: 14,
                            fontWeight: 400,
                            color: "#444",
                          }}
                        >
                          Learn Smart Search
                          <img
                            src="https://upload.wikimedia.org/wikipedia/commons/4/42/YouTube_icon_%282013-2017%29.png"
                            alt="YouTube"
                            style={{
                              width: 20,
                              // verticalAlign: "middle",
                              marginBottom: "10px",
                            }}
                          />
                        </span>
                      </button>
                    </Nav.Item>
                  </Nav>
                  <div className="group">
                    <input
                      className="input"
                      type="text"
                      value={search}
                      onChange={(e) => {
                        setSearchData(e.target.value);
                        setSearch(e.target.value);
                      }}
                      placeholder="Type Message"
                      disabled={loading}
                    />
                    <div className="main-search-btn">
                      <Button
                        type="submit"
                        className="search-button"
                        disabled={loading || search === ""}
                      >
                        <svg
                          width="25px"
                          height="25px"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.39999 6.32003L15.89 3.49003C19.7 2.22003 21.77 4.30003 20.51 8.11003L17.68 16.6C15.78 22.31 12.66 22.31 10.76 16.6L9.91999 14.08L7.39999 13.24C1.68999 11.34 1.68999 8.23003 7.39999 6.32003Z"
                            stroke="#fff"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M10.11 13.6501L13.69 10.0601"
                            stroke="#fff"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </Button>
                    </div>
                  </div>
                </div>
                <span className="footer-nots">
                  TenderGPT can make mistakes. Consider checking important
                  information.
                </span>
              </form>
            </Col>
          </div>
          {/* ) : (
            "" */}
          {/* // )} */}
        </div>
      </Tab.Container>
      <Login
        showModal={openModal}
        setopenModal={setopenModal}
        handleClose={() => setopenModal(false)}
      />
      <PaymentModal show={topUpPaymentModal} handleClose={() => setTopUpPaymentModal(false)} objData={objData} />
      <ViewPaymentHistory PaymentModalIsOpen={viewPaymentModalIsOpen} handlePaymentModalClose={() => setViewPaymentModalIsOpen(false)} />
      <ReferAndEarn show={showModalReferAndEarn} handleClose={() => setShowModalReferAndEarn(false)} />

    </>
  );
}

export default TabComponent;
